export default __webpack_public_path__ + "static/media/7.cb2369e5.png";